<template>
  <nav-bar safe-area-inset-top v-bind="$attrs" :class="{ 'nav-bar_rtl': language === 'ar' }">
    <template #left>
      <span v-if="isSlotLeft" class="nav-bar__title">{{ title }}</span>
      <slot v-else name="navLeft"></slot>
    </template>
    <template #right>
      <span v-if="isSlotRight && closeable" class="nav-bar__close" @click="handleClose">
        <m-svg-close :width="'17px'" :height="'17px'" color="#2F2F2F" strokeWidth="4"></m-svg-close>
      </span>
      <slot v-else name="navRight"></slot>
    </template>
  </nav-bar>
</template>

<script lang='ts'>
import { getRequestLanguage } from '@/api/utils'
import { NavBar } from 'vant'
import { reactive, toRefs, onMounted, Ref, PropType, getCurrentInstance, ComponentInternalInstance, computed } from 'vue'

interface MNavBarState {
  isSlotLeft: Ref<boolean>
  isSlotRight: Ref<boolean>
  handleClose: () => void
  language: Ref<string>
}

export default {
  name: 'MNavBar',
  components: {
    NavBar
  },
  props: {
    title: {
      type: String as PropType<string>,
      default: '标题'
    },
    onClose: {
      type: Function as PropType<() => void>,
      required: false
    },
    closeable: {
      type: Boolean as PropType<boolean>,
      default: true
    }
  },
  setup(props: Readonly<{
    onClose?: () => void
  }>): MNavBarState {
    const { slots } = getCurrentInstance() as ComponentInternalInstance
    const state = reactive({
      isSlotLeft: true,
      isSlotRight: true
    })

    const language = computed(() => {
      return getRequestLanguage()
    })

    onMounted(() => {
      if (slots?.navLeft) {
        state.isSlotLeft = false
      } else {
        state.isSlotLeft = true
      }
      if (slots?.navRight) {
        state.isSlotRight = false
      } else {
        state.isSlotRight = true
      }
    })

    const handleClose = () => {
      props.onClose && props.onClose()
    }

    return {
      ...toRefs(state),
      handleClose,
      language
    }
  }
}
</script>
<style lang='scss' scoped>
.nav-bar_rtl {
  direction: rtl;
}

:deep(.van-nav-bar__left) {
  position: initial !important;
}

:deep(.van-nav-bar__right) {
  position: initial !important;
}

@include b(nav-bar) {
  @include e(title) {
    max-width: 400px;
    font-size: 30px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    line-height: 43px;
    color: #262928;
    @include box-clamp(1)
  }

  @include e(close) {
    display: block;
  }
}
</style>
